import { Component, Input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { SpanTooltipComponent } from '@shared/components/span-tooltip/span-tooltip.component';

@Component({
  selector: 'tree-selected-multiple',
  templateUrl: './tree-selected-multiple.component.html',
  standalone: true,
  imports: [NgClass, NgStyle, SpanTooltipComponent]
})
export class TreeSelectedMultipleComponent{
  @Input() level: number = 1;
  @Input() list: any = [];
  nextLevel: number = this.level + 1;
}
